import type { CertificateResponse } from '../../data-access/api/responses.js';
import { parseDateForPicker } from '../../data-access/dates.js';
import { createEmptyStorageLocation, INITIAL_FORM_VALUES } from './defaults.js';
import type { FormValues } from './types.js';

export const mapCertificateToFormValues = (certificate: CertificateResponse): FormValues => {
  const transitLimit = certificate.transitLimit ?? certificate.propertyOnBoardLimit;

  return {
    certificateIssuedTo: certificate.certificateIssuedTo ?? '',
    customerAddress: certificate.customerAddress ?? '',
    countryCode: certificate.countryCode ?? '',
    policyYear: certificate.policyYear ? String(certificate.policyYear) : '',
    certificateTemplateId: certificate.certificateTemplateId ?? '',

    effectiveDate: parseDateForPicker(certificate.effectiveDate),
    currency: certificate.currency || transitLimit?.currency || INITIAL_FORM_VALUES.currency,
    policyExpirationDate: parseDateForPicker(certificate.policyExpirationDate),
    policyNumber: certificate.policyNumber ?? '',
    contractingEntity: certificate.contractingEntity ?? '',

    propertyOnBoardLimit: certificate.propertyOnBoardLimit?.amount ?? 0,
    transitLimit: certificate.transitLimit?.amount || certificate.propertyOnBoardLimit?.amount || 0,
    atmLimit: certificate.atmLimit?.amount ?? 0,
    compusafeLimit: certificate.compusafeLimit?.amount ?? 0,
    moneyProcessingLimit: certificate.moneyProcessingLimit?.amount ?? 0,

    storageLocations: (certificate.storageLocations ?? []).map((location, index) => ({
      ...createEmptyStorageLocation(index + 1),
      storageLocation: location.storageLocation,
      limitStorage: location.amount ?? 0,
    })),

    situation: certificate.situation ?? '',
    sanctionedCountryTouchpoint: Boolean(certificate.sanctionedCountryTouchpoint),
    additionalComments: certificate.additionalComments ?? '',
  };
};
